import Image1 from "../../assets/certificate1.jpeg";
import Image2 from "../../assets/certificate2.jpeg";
import Image3 from "../../assets/certificate3.png";
import Image4 from "../../assets/certificate4.jpeg";
import Image5 from "../../assets/certificate5.jpg";

export const Data = [
	{
		id: 1,
		image: Image1,
		title: "The Complete JavaScript Course 2023: From Zero to Expert!",
		description:
			"This certificate above verifies that Vinojini Paramasivam successfully completed the course The Complete JavaScript Course 2023: From Zero to Expert! on 05/22/2019 as taught by Jonas Schmedtmann on Udemy. The certificate indicates the entire course was completed as validated by the student. The course duration represents the total video hours of the course at time of most recent completion.",
	},
	{
		id: 2,
		image: Image2,
		title: "Java Programming: Complete Beginner to Advanced",
		description:
			"This certificate above verifies that Vinojini Paramasivam successfully completed the course Java Programming: Complete Beginner to Advanced on 03/13/2023 as taught by CodeIn Academy on Udemy. The certificate indicates the entire course was completed as validated by the student. The course duration represents the total video hours of the course at time of most recent completion.",
	},
	{
		id: 3,
		image: Image3,
		title: "“Learning Java 8” by Peggy Fisher!",
		description: "LinkedIn Learning",
	},
	{
		id: 4,
		image: Image4,
		title: "React.js Essential Training",
		description: "LinkedIn Learning",
	},
	{
		id: 5,
		image: Image5,
		title: "Java lambdas and streams",
		description: "LinkedIn Learning",
	},
	// {
	// 	id: 2,
	// 	image: Image2,
	// 	title: "Hiiiii",
	// 	description:
	// 		"hiii hhiiii hiihihih nkgnnfkjkjrv  kjkj f k jk  kf jk jk  r rj  rj rjrgjvrtj jrg jkr jrg rg jr",
	// },
	// {
	// 	id: 3,
	// 	image: Image3,
	// 	title: "Hiiiii",
	// 	description:
	// 		"hiii hhiiii hiihihih nkgnnfkjkjrv  kjkj f k jk  kf jk jk  r rj  rj rjrgjvrtj jrg jkr jrg rg jr",
	// },
];
